import { render } from "./DnsRecordActions.vue?vue&type=template&id=a199462a&scoped=true&lang=pug"
import script from "./DnsRecordActions.vue?vue&type=script&setup=true&lang=js"
export * from "./DnsRecordActions.vue?vue&type=script&setup=true&lang=js"

import "./DnsRecordActions.vue?vue&type=style&index=0&id=a199462a&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a199462a"]])

export default __exports__